var map = {
	"./auth-background.webp": 1924,
	"./close-btn.webp": 1925,
	"./icon-caution.webp": 1926,
	"./icon-checked.webp": 1927,
	"./icon-contact-us.webp": 1928,
	"./icon-email.webp": 1929,
	"./icon-eye-close.webp": 1930,
	"./icon-eye-open.webp": 1931,
	"./icon-forget-phone.webp": 1932,
	"./icon-forget-whatsapp.webp": 1933,
	"./icon-google.webp": 1934,
	"./icon-login-email-2.webp": 1935,
	"./icon-login-email.webp": 1936,
	"./icon-password.webp": 1937,
	"./icon-robot-select.webp": 1938,
	"./icon-robot-unselect.webp": 1939,
	"./icon-telegram.webp": 1940,
	"./icon-user.webp": 1941,
	"./jackpot-cn.webp": 1942,
	"./jackpot-mobile-cn.webp": 1943,
	"./jackpot-mobile-ms.webp": 1944,
	"./jackpot-mobile.webp": 1945,
	"./jackpot-ms.webp": 1946,
	"./jackpot.webp": 1947,
	"./login-bg.webp": 1948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 110;